<template>
    <div v-if="local_envoi_postal.propose">
        <div class="spo-card rounded bordered p-1 my-2">
            <div class="text-h6">Envoi postal du dossard</div>
            <div class="text-body mt-2">
                Faites-vous envoyer votre dossard à l'adresse de votre choix avant l'événement.
            </div>
            <v-checkbox color="primary-dark" hide-details @change="updateSelection"
                :label="'Souscrire à l\'envoi postal pour ' + local_envoi_postal.prix + '€'"
                v-model="local_envoi_postal.selected">
            </v-checkbox>
            <v-textarea v-if="local_envoi_postal.selected" class="mt-2" v-model="local_envoi_postal.adresse_postale"
                :placeholder="adresse_postale_placeholder" rows="4" auto-grow hide-details="auto"
                @update:model-value="updateSelection">
            </v-textarea>
        </div>
    </div>
</template>

<script>
export default {
    props: ["envoi_postal", "commande_inscription"],
    data() {
        return {
            local_envoi_postal: {},
            adresse_postale_placeholder: "NOM PRENOM\nNUMÉRO ET RUE\nCODE POSTAL VILLE",
        };
    },
    mounted() {
        this.local_envoi_postal = this.envoi_postal;
    },
    methods: {
        updateSelection() {
            if (!this.local_envoi_postal.selected) {
                this.local_envoi_postal.adresse_postale = "";
            }
            Object.assign(this.envoi_postal, {
                selected: this.local_envoi_postal.selected,
                adresse_postale: this.local_envoi_postal.adresse_postale,
            });
            this.$emit('updateEnvoiPostal');
        },
    },
}
</script>

<style lang="scss" scoped></style>
